// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"OccasionsFormItems_titleWrapper__XGOl8","subtitleWrapper":"OccasionsFormItems_subtitleWrapper__8MUYt","wrapper":"OccasionsFormItems_wrapper__7xcwx"};